import { bookingWebsiteOrigin } from "@/features/business-website/utils/websiteUrl";

export const manageSubscriptionPath = "/manage-subscription";

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isBusinessIdParam = (value: string | null): value is string => !!value && uuid.test(value);

/** Subscriptions are managed on the web: fropp.io redirects this link to the app's standalone page. */
export function getManageSubscriptionUrl(businessId: string): string {
  const url = new URL(manageSubscriptionPath, import.meta.env.VITE_BOOKING_URL || bookingWebsiteOrigin);
  url.searchParams.set("business_id", businessId);
  return url.href;
}
